import { render, staticRenderFns } from "./WsUserUpload.vue?vue&type=template&id=2a5f0f24"
import script from "./WsUserUpload.vue?vue&type=script&lang=js"
export * from "./WsUserUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports